import "asciinema-player/dist/bundle/asciinema-player.css";
import { useStyletron } from "baseui";
import React, { useEffect, useRef, useState } from "react";

type AsciinemaPlayerProps = {
  src: string;
  // START asciinemaOptions
  cols?: string;
  rows?: string;
  autoPlay?: boolean;
  preload?: boolean;
  loop?: boolean | number;
  startAt?: number | string;
  speed?: number;
  idleTimeLimit?: number;
  theme?: string;
  poster?: string;
  fit?: string;
  fontSize?: string;
  // END asciinemaOptions
};

export const AsciinemaPlayer = ({ src, ...asciinemaOptions }: AsciinemaPlayerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [player, setPlayer] = useState<typeof import("asciinema-player")>();
  useEffect(() => {
    void import("asciinema-player").then((p) => {
      setPlayer(p);
    });
  }, []);

  useEffect(() => {
    const currentRef = ref.current;
    const instance = player?.create(src, currentRef, asciinemaOptions);
    return () => {
      instance?.dispose();
    };
  }, [src, player, asciinemaOptions]);

  const [css, $theme] = useStyletron();

  return (
    <div
      className={css({
        maxWidth: "min(900px, 100%)",
        maxHeight: "600px",
        marginTop: $theme.sizing.scale700,
        marginBottom: $theme.sizing.scale700,
        marginLeft: "auto",
        marginRight: "auto",
      })}
      ref={ref}
    />
  );
};
